enum PlannerDossierCategory {
  EXPECTED = 'expected',
  TODAY = 'today',
  EARLIER = 'earlier',
  WORK_STARTED = 'workstarted',
}

export default PlannerDossierCategory;